import React from 'react';

/**
 * The fields of one work record, as the pop-up lists them.
 *
 * THE SERVER DECIDES WHICH FIELDS EXIST, THEIR LABELS AND THEIR ORDER. This
 * renders `detail.fields` as it arrives and reads nothing out of it by name —
 * no branch here looks for a "Status" line or a "Value" line. That is what lets
 * a type send only the columns its own schema carries: a record with no
 * resolution date sends no resolution-date line, rather than this rendering a
 * blank cell for a field that does not exist.
 *
 * IT ALSO MEANS THE LABELS ARE ALREADY TRANSLATED. They come from `__()` on the
 * server, so nothing here may key off their text — under Arabic the same field
 * arrives with a different label, and a client-side match on "Status" would
 * silently stop matching.
 *
 * EVERY VALUE IS RENDERED AS A REACT CHILD. `TableTooltip` concatenates into
 * `dangerouslySetInnerHTML`; no field value goes near it, and none is rendered
 * as markup here.
 *
 * TOLERATES AN ABSENT OR EMPTY LIST. There is no error boundary anywhere in
 * this app and this mounts on the post-login landing page, so a missing
 * `fields` must render nothing rather than throw and blank Home.
 */
export default function WorkFieldsBody({ detail }) {
    const fields = detail?.fields ?? [];

    if (fields.length === 0) {
        return null;
    }

    return (
        <dl className="tw-mb-0 tw-flex tw-flex-col tw-gap-2">
            {fields.map((field) => (
                <div key={field.label} className="tw-grid tw-grid-cols-3 tw-gap-4">
                    <dt className="tw-col-span-1 tw-text-xs tw-font-normal tw-text-charcoal-60">{field.label}</dt>
                    <dd className="tw-col-span-2 tw-mb-0 tw-text-sm tw-text-charcoal">{field.value}</dd>
                </div>
            ))}
        </dl>
    );
}
